import React, { useEffect, useState, } from "react";
import PropTypes from "prop-types";
import NavBar from "./NavBar";
import { Box, Link, useMediaQuery } from "@mui/material";
import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import TopBar from "../HomeLayout/TopBar";
import { useLocation, useNavigate } from "react-router-dom";
// import { shallowEqual, useSelector } from "react-redux";
import Footer from "src/components/Footer";

const styles = {

  gapManage: {
    flex: 1, overflow: 'auto', padding: "0 25px" ,
    "@media(max-width:600px)": {
      padding: "0 5px",
    },
    "@media(max-width:960px)": {
      padding: "0 10px",    },
  },}

const DashboardLayout = ({ children }) => {
  const theme = useTheme();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  // let userTabViewData = useSelector((state) => state?.user?.user?.tabView, shallowEqual);
  // let userIconViewData = useSelector((state) => state?.user?.user?.iconView, shallowEqual);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const navigate = useNavigate();

  // useEffect(() => {
  //   setIsCollapsed(true)
  //   // This effect runs whenever tabView changes
  //   if (userTabViewData) {
  //     setIsDrawerOpen(true);
  //   } else {
  //     setIsDrawerOpen(false);
  //   }
  // }, [userTabViewData]);

  const ismdUp = useMediaQuery(theme.breakpoints.down(1000));

  const DrawerContainer = styled(Box)(({ theme, open, anchor }) => ({
    [anchor]: open ? 0 : '-250px', // Adjust -250px based on your drawer width
    transition: '0.3s',
    width: isCollapsed ? '400px' : "26px",
    height: '100%',
    backgroundColor: "#F9F9F9",
    zIndex: 1200, // Make sure it’s above other content
    overflow: isCollapsed ? "auto" : "hidden",
    borderRight: "none !important"
  }));

  const Overlay = styled(Box)(({ open }) => ({
    display: open ? 'block' : 'none',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    zIndex: 1100, // Just below the drawer
  }));

  const CustomDrawer = React.memo(({ anchor = 'right', open, children }) => {
    return (
      <DrawerContainer open={open} anchor={anchor}>
        {children}
      </DrawerContainer>
    );
  });
  const location = useLocation();
  const pathParts = location.pathname.split("/").filter(Boolean);
  const prefix = localStorage.getItem("prefix")
  const userId = localStorage.getItem("userId");
  const validateRedirectionPath = (pathToHere)=>{
    // /reports/sales_report
    if (pathToHere == "sales"){
      navigate("/reports/sales_report")
    } else if (pathToHere == "Master") {
      navigate(`/dashboard/${prefix}/${userId}`)
    }
    else if (pathToHere == "purchases"){
      navigate(`/reports/mis_report`)
    }

  }
  const masterPaths = [
    "products",
    "products_price_variation",
    "supplier",
    "users",
    "product_category",
    "Brands",
    "Units",
    "customers",
    "ContraList",
  ];
  return (
    <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} />
      <nav className="breadcrumbs">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <Link onClick={() => { navigate(`/dashboard/${prefix}/${userId}`)}}>
                <i className="fa fa-home"></i>
              </Link>
              {/* Add "Master" if path is in masterPaths */}
              {masterPaths.includes(pathParts[0]) ? (
                <span className="crumb">
                  <span className="divider"> &gt; </span>
                  <Link onClick={() => {
                    validateRedirectionPath("Master")
                  }} >Master</Link>
                </span>
              ):""}
              {pathParts.map((part, index) => {
                // Rebuild the path up to the current part
                const pathToHere = `${pathParts.slice(0, index + 1).join("/")}`;
                
                // Capitalize the part for display
                const formattedPart =
                  part.charAt(0).toUpperCase() + part.slice(1).replace(/-/g, " ");

                return (
                  <span key={index} className="crumb">
                    <span className="divider"> &gt; </span>
                    {index === pathParts.length - 1 ? (
                      <span className="last-crumb">{formattedPart}</span>
                    ) : (
                        <Link onClick={()=>{
                          validateRedirectionPath(pathToHere)
                        }} >{formattedPart}</Link>
                    )}
                  </span>
                );
              })}
            </div>
          </div>
        </div>
      </nav>
      <Box sx={{ display: 'flex', flex: 1, overflow: 'hidden', margin: "12px 0 40px 0", }}>
        <Box sx={{
          // minWidth: "278px",
          // "@media(max-width:999px)": {
            minWidth: "auto",
          // },
        }}>
          <NavBar onMobileClose={() => setMobileNavOpen(false)} openMobile={isMobileNavOpen} />
        </Box>
        <Box sx={ styles.gapManage}>
          {children}
        </Box>
      </Box>
      <Footer />

    </Box>

  );
};

DashboardLayout.propTypes = {
  children: PropTypes.node,
};

export default DashboardLayout;
